module.exports = __webpack_public_path__ + "assets/img/69@3x.7b23d79d.png";